<mat-icon
  class="filter-top-btn"
  (click)="isFilterOpen = true"
  matTooltip="Table Filter"
  >filter_list</mat-icon
>
<div class="container">
  <div class="page-header">
    <div>
      <h2 class="page-subtitle">
        <mat-icon>directions_boat</mat-icon>
        AIS Vessel Tracking
      </h2>
    </div>
  </div>

  <div class="filter-container" [class.open]="isFilterOpen">
    <div class="filter">
      <!-- Header -->
      <div class="filter-header">
        <span style="color: aliceblue">Filters</span>

        <mat-icon class="close-btn" (click)="isFilterOpen = false"
          >close</mat-icon
        >
      </div>

      <!-- Body -->
      <form [formGroup]="filterForm" class="filter-body">
        <div class="filter-section">
          <h4>Vessel Details</h4>

          <label class="shipNameLabel dark-label"> Vessel Name </label>

          <input
            type="text"
            class="form-control"
            id="vesselName"
            formControlName="vesselName"
            placeholder="Enter Vessel Name"
            autocomplete="off"
          />

          <label class="shipNameLabel dark-label"> IMO Number </label>

          <input
            type="text"
            class="form-control"
            id="imoNumber"
            formControlName="imoNumber"
            placeholder="Enter IMO Number"
            autocomplete="off"
          />

          <label class="shipNameLabel dark-label"> Vessels</label>
          <select class="form-control" formControlName="vesselType">
            <option value="all">All Vessels</option>
            <option value="true">Added Vessels</option>
          </select>
        </div>
      </form>

      <!-- Footer Buttons -->
      <div class="filter-footer">
        <button class="btn clear-btn" (click)="clearClick()">
          <mat-icon>clear_all</mat-icon>
          Clear
        </button>

        <button class="btn apply-btn" (click)="filterClick()">
          <mat-icon>filter_list</mat-icon>
          Apply
        </button>
      </div>
    </div>
  </div>
  <div class="text-right">
    <button
      class="btn btn-light hover-button mail me-2"
      (click)="exportToCSV()"
    >
      <mat-icon>download</mat-icon>
      Export
    </button>
    <button class="btn btn-light hover-button mail" (click)="openAddPopup()">
      <mat-icon>add</mat-icon>
      Add Vessel
    </button>
  </div>
  <!-- <div class="stats-row">

  <div class="stat-card">
    <mat-icon>directions_boat</mat-icon>
    <div>
      <span>Total Vessels</span>
      <h3>{{ filteredData?.length || 0 }}</h3>
    </div>
  </div>

  <div class="stat-card">
    <mat-icon>satellite_alt</mat-icon>
    <div>
      <span>Visible On Map</span>
      <h3>{{ paginatedData?.length || 0 }}</h3>
    </div>
  </div>

  <div class="stat-card">
    <mat-icon>public</mat-icon>
    <div>
      <span>AIS Tracking</span>
      <h3>Live</h3>
    </div>
  </div>

</div> -->
  <div class="row content-row">
    <div class="col-12 table-wrapper">
      <div class="table-container scroll-bar">
        <table
          class="mat-elevation-z8"
          id="style-4"
          matSort
          (matSortChange)="sortData($event)"
          [ngClass]="{ 'dark-table': isDarkMode() }"
        >
          <thead class="sticky-header">
            <tr>
              <th mat-sort-header="vessel_name">Vessel Name</th>
              <th mat-sort-header="imo">IMO Number</th>
              <th mat-sort-header="segment">Segment</th>
              <th mat-sort-header="commercial_operator">Commercial Operator</th>
              <th mat-sort-header="ingested_date">Ingested Date</th>
              <th mat-sort-header="deactivate_date">Deactivation Date</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let item of paginatedData">
              <td>{{ item.vessel_name }}</td>
              <td>{{ item.imo }}</td>
              <td>{{ item.segment }}</td>
              <td>{{ item.commercial_operator }}</td>
              <td>{{ formatDate(item.ingested_date) }}</td>
              <td>{{ formatDate(item.deactivate_date) }}</td>
              <td>
                <mat-icon
                  style="color: red; cursor: pointer"
                  (click)="deleteAisVessel(item.imo)"
                >
                  delete
                </mat-icon>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <mat-paginator
        [length]="paginatedData.length"
        [pageSizeOptions]="[100]"
        [pageSize]="itemsPerPage"
        (page)="onPageChange($event)"
        [ngClass]="{ 'dark-paginator': isDarkMode() }"
        showFirstLastButtons
      ></mat-paginator>
    </div>
    <div class="col-12 map-wrapper">
      <button class="label-toggle" (click)="toggleLabels()">
        <mat-icon>
          {{ showVesselLabels ? "visibility" : "visibility_off" }}
        </mat-icon>

        <span>
          {{ showVesselLabels ? "Labels On" : "Labels Off" }}
        </span>
      </button>
      <div id="AISMap" class="map-container"></div>
    </div>
  </div>

  <div *ngIf="isAddPopupOpen" class="popup-overlay">
    <div class="modal-content">
      <div class="text-right">
        <mat-icon class="close-button" (click)="isAddPopupOpen = false">
          close
        </mat-icon>
      </div>

      <div class="content">
        <h6 class="text-center">
          <strong><i class="fa-solid fa-ship alrt"></i></strong>
        </h6>

        <p class="message">Add AIS Vessel</p>
        <label class="dropdown-label">IMO Number</label>
        <input
          class="form-control"
          [(ngModel)]="newVessel.imo"
          (input)="onImoChange()"
          maxlength="7"
          placeholder="Enter IMO Number"
        />
        <br />
        <label class="dropdown-label">Vessel Name</label>
        <input
          class="form-control"
          [(ngModel)]="newVessel.vessel_name"
          placeholder="Enter Vessel Name"
        />
      </div>

      <div class="row">
        <button class="btn btn-light hover-clear" (click)="addAisVessel()">
          Save
        </button>

        <button
          class="btn btn-light hover-clear"
          (click)="isAddPopupOpen = false"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>
